// The canonical dataModel gender values ("male"/"female") are shared with legacy
// hosts, while form option submit values ("m"/"f") are fixed by the Search Form
// Service metadata. These helpers translate at the dataModel <-> form boundary.
export const GENDER_FIELD_KEY = "SelfGender";

const DATA_MODEL_TO_FORM: Record<string, string> = { male: "m", female: "f" };
const FORM_TO_DATA_MODEL: Record<string, string> = { m: "male", f: "female" };

export const genderDataModelToFormValue = (value: string): string => DATA_MODEL_TO_FORM[value] ?? value;
export const genderFormToDataModelValue = (value: string | null): string | null =>
    value == null ? value : (FORM_TO_DATA_MODEL[value] ?? value);
